export default __webpack_public_path__ + "static/media/games.6d381015.png";